// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2wUHK","label":"Category_label__11Lb-","content":"Category_content__SomXH","header":"Category_header__2WqaW","location":"Category_location__Yw0cT"};